const updateTapStory = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'gumbo') {
            const { gameData: { teams, status } = {} } = action?.data || {};
            const homeTeam = teams?.home;
            const awayTeam = teams?.away;
            return {
                ...state,
                awayTeamId: awayTeam?.id,
                homeTeamId: homeTeam?.id,
                gameState: status?.abstractGameState
            };
        } else if (datasource === 'schedule') {
            const { story = '' } = action?.data || {};
            return {
                ...state,
                storyUrl: story
            };
        }
    }

    return state;
};

export default updateTapStory;
